/**
 * @file: PackConf.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 应急管理打包数据设置
 */
import request from '@/utils/request'

/**
 * 获取应急管理打包数据列表(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function packConfList(data) {
  return request({
    type: 'biz',
    url: 'packConf/list',
    method: 'post',
    data
  })
}

/**
 * 设置应急管理打包数据(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function packConfUpdateCheck(data) {
  return request({
    type: 'biz',
    url: 'packConf/update/check',
    method: 'post',
    data
  })
}

/**
 * 设置应急管理信息(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function packConfUpdateData(data) {
  return request({
    type: 'biz',
    url: 'packConf/update/data',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/PackConf.js